// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2YS-b","vLegacy":"SelectSecondary_vLegacy__3ixKo","error":"SelectSecondary_error__10Osv","disabled":"SelectSecondary_disabled__2DeEo"};